import { ApiLoadingState } from '../../../middleware/api/apiList'
import { ResetAllCallbackType } from '../../../middleware/hooks/usePaginationRevised'
import { ValidationError } from '../../commonTypes'

export type FinanceInformation = {
  financeId: number
  pfAccountNumber: null | string
  panCardAccountNumber: string
  uaNumber: null | string
  employeeId: number
  aadharCardNumber: null | string
  financeFilePath: null | string
  financeFileName: null | string
}

export type BankDetails = {
  bankId: number
  bankName: string
  bankAccountNumber: string
  ifscCode: null | string
  employeeId: number
}

export type FinanceDetails = {
  id: null | number
  employeeId: number
  employeeName: string
  dob?: null | string
  financeDetails: FinanceInformation
  bankDetails: BankDetails[]
}
export type GetFinanceDetailsResponse = {
  list: FinanceDetails[]
  size: number
}

export type EmployeeAccountSliceState = {
  isLoading: ApiLoadingState
  selectedEmploymentStatus: EmploymentAccountStatus
  error: ValidationError
  financeData: FinanceDetails[]
  listSize: number
  selectStatusValue: string
}

export type EmployeeAccountApiProps = {
  startIndex?: number
  endIndex?: number
  employeeName: string
  status: string
}
export enum EmploymentAccountStatus {
  'active' = 'Active',
  'inactive' = 'InActive',
}
export type EmployeeAccountExpandableTableProps = {
  currentPage: number
  pageSize: number
  reloadData: (size: number, page: number) => void
  resetPagination: ResetAllCallbackType
}

export type DownloadFinanceList = {
  employeeNameSearch?: string
  token?: string
  status: string
}
